var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded-0",attrs:{"outlined":"","color":"gray0","id":"pdfBtn","height":"4vh"},on:{"mousedown":_vm.downloadFile}},[_vm._v(" pdf ")])
}
var staticRenderFns = []

export { render, staticRenderFns }